/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { getJobRunnerService } from '../../../../Services/job-runner';

export const getJobRunnerTarget = (): string => {
  const jobRunnerService = getJobRunnerService();
  const jobRunnerTargetBaseDomain = `https://${process.env.DXP_CONSOLE_DOMAIN}`;

  const jobRunnerUrl = `${jobRunnerService.getBaseServiceUrl()}/executions/begin`;

  if (jobRunnerUrl.startsWith(jobRunnerTargetBaseDomain)) {
    return jobRunnerUrl;
  }

  // For non-local environments, the base service URL is missing the base domain due to how
  // DXP Console sessions are handled. Append the base domain needed for the job runner target.
  return `${jobRunnerTargetBaseDomain}${jobRunnerUrl}`;
};
